import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination } from "swiper/modules";
import i18n from "../i18n";

const Carousel = () => {
  const [langTick, setLangTick] = useState(0);

  useEffect(() => {
    const onLang = () => setLangTick((x) => x + 1);
    i18n.on("languageChanged", onLang);
    return () => i18n.off("languageChanged", onLang);
  }, []);

  // eslint-disable-next-line no-unused-vars
  const _ = langTick;

  const testimonials = [
    {
      title: i18n.t("carousel.items.brz1.title"),
      text: i18n.t("carousel.items.brz1.text"),
      author: i18n.t("carousel.items.brz1.author"),
      logo: "brz.png",
    },
    {
      title: i18n.t("carousel.items.brz2.title"),
      text: i18n.t("carousel.items.brz2.text"),
      author: i18n.t("carousel.items.brz2.author"),
      logo: "brz.png",
    },
    {
      title: i18n.t("carousel.items.brz3.title"),
      text: i18n.t("carousel.items.brz3.text"),
      author: i18n.t("carousel.items.brz3.author"),
      logo: "brz.png",
    },
    {
      title: i18n.t("carousel.items.pva.title"),
      text: i18n.t("carousel.items.pva.text"),
      author: i18n.t("carousel.items.pva.author"),
      logo: "pv.png",
    },
    {
      title: i18n.t("carousel.items.lv1871.title"),
      text: i18n.t("carousel.items.lv1871.text"),
      author: i18n.t("carousel.items.lv1871.author"),
      logo: "lv1871.png",
    },
    {
      title: i18n.t("carousel.items.svs.title"),
      text: i18n.t("carousel.items.svs.text"),
      author: i18n.t("carousel.items.svs.author"),
      logo: "svs.png",
    },
  ];

  return (
    <div className="w-full bg-gray-100">
      <div className="w-full max-w-5xl mx-auto pt-20 pb-20 relative px-4 sm:px-6">
        <h2 className="mt-2 sm:mt-4 mb-10 text-center text-gray-600 text-xl sm:text-2xl md:text-3xl font-medium max-w-3xl mx-auto">
          {i18n.t("carousel.title")}
        </h2>

        <div className="relative px-0 sm:px-10">
          <Swiper
            modules={[Navigation, Pagination]}
            navigation
            pagination={{ clickable: true }}
            simulateTouch={true}
            allowTouchMove={true}
            slidesPerView={1}
            spaceBetween={20}
            className="w-full"
          >
            {testimonials.map((testimonial, index) => (
              <SwiperSlide key={index}>
                <div className="mt-4 mb-12 mx-0 sm:ml-20 sm:mr-20 bg-white shadow-lg rounded-2xl p-6 cursor-pointer">
                  <h3 className="text-lg font-bold mb-4">{testimonial.title}</h3>

                  <p className="text-gray-600 italic mb-4">
                    "{testimonial.text}"
                  </p>

                  <div className="flex items-center mt-4">
                    <img
                      src={`${process.env.PUBLIC_URL}/logos/${testimonial.logo}`}
                      alt=""
                      aria-hidden="true"
                      className="h-8 mr-3"
                    />
                    <span className="text-gray-800 font-semibold">
                      {testimonial.author}
                    </span>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          <style jsx>{`
            @media (max-width: 639px) {
              .swiper-button-prev,
              .swiper-button-next {
                display: none;
              }
            }

            .swiper-button-prev,
            .swiper-button-next {
              top: 50%;
              transform: translateY(-50%);
              width: 24px;
              height: 24px;
              z-index: 10;
              color: black;
              position: absolute;
            }
            .swiper-button-prev {
              left: -4px;
            }
            .swiper-button-next {
              right: -4px;
            }
            .swiper-button-prev::after,
            .swiper-button-next::after {
              font-size: 18px;
            }

            .swiper-pagination {
              margin-top: 12px;
            }
          `}</style>
        </div>
      </div>
    </div>
  );
};

export default Carousel;

























